import { Layout } from "antd";
import { Outlet, useNavigate } from "react-router-dom";
import "../../antd.override.css";
import "./index.css";

import { useState } from "react";
import { HeaderComponents } from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import { PathConstants } from "../../pathConstants/pathConstants";

export const PageLayout = () => {
  const { Sider, Content, Header } = Layout;
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  return (
    <>
      <Layout className="layout-height ">
        <Sider
          breakpoint="sm"
          collapsedWidth="0"
          className="sider"
          theme="light"
          width={100}
          collapsed={collapsed}
          onCollapse={toggleCollapsed}
        >
          <img
            src="/assets/logo.svg"
            className="logo "
            alt="logo"
            onClick={() => {
              if (
                localStorage.getItem("user_role") === "1" ||
                localStorage.getItem("user_role") === "2"
              ) {
                navigate("/overview");
              } else if (localStorage.getItem("user_role") === "3") {
                navigate(PathConstants.WARE_HOUSE_MANAGEMENT);
              } else {
                navigate(PathConstants.FINISHED_GOODS);
              }
            }}
          ></img>
          <Sidebar setOpen={setCollapsed} collapsed={collapsed} />
        </Sider>

        <Layout>
          <Header className="header-style">
            <HeaderComponents
              collapsed={collapsed}
              toggleCollapsed={toggleCollapsed}
            />
          </Header>
          <Content className="content-style  form-header">
            <div className="outlet-style ">
              <Outlet />
            </div>
          </Content>
        </Layout>
        {/* </div> */}
      </Layout>
    </>
  );
};
